export default __webpack_public_path__ + "static/media/ex2.a98fec2f.png";